import React from 'react';
import checkedIcon from 'static/images/icon/pwd-checked.svg';
import uncheckedIcon from 'static/images/icon/pwd-unchecked.svg';
import warningIcon from 'static/images/icon/pwd-warning.svg';
import classlist from 'utils/classlist';
import styles from './style.scss';

export interface PwdRiskProps {
    password: string;
    confirmPassword?: string;
}

export const riskPatterns: RegExp[] = [
    /\d/, // 数字
    /[a-zA-Z]/, // 大小写字母
    /[^0-9a-zA-Z]/ // 非数字、字母
];

// 三种类型检查
export const pwdTypeChecker = (value: string): boolean => {
    const typesCount = value ? riskPatterns.reduce((ret, reg) => (ret += reg.test(value) ? 1 : 0), 0) : 0;

    return typesCount === 3;
};

// 8-24长度检查
export const pwdLengthChecker = (value: string): boolean => {
    // 8-24长度
    return value ? value.length >= 8 && value.length <= 24 : false;
};

// 确认密码一致检查
export const confirmPasswordChecker = (password: string, confirmPassword: string): boolean => {
    return password === confirmPassword;
};

const styleMap = {
    checked: { icon: checkedIcon, className: styles.checked },
    warning: { icon: warningIcon, className: styles.warning },
    unchecked: { icon: uncheckedIcon, className: styles.unchecked }
};

/**
 * @description
 * 密码规则显示
 *
 * 长度 8 - 24 位
 * 大小写字母 + 数字 + 标点
 */
export const PwdRisk: React.FC<PwdRiskProps> = ({ password, confirmPassword }) => {
    const lengthStyle = password?.length ? (pwdLengthChecker(password) ? 'checked' : 'warning') : 'unchecked';

    const typeStyle = password?.length ? (pwdTypeChecker(password) ? 'checked' : 'warning') : 'unchecked';

    const confirmPasswordStyle = confirmPassword?.length
        ? confirmPasswordChecker(password, confirmPassword)
            ? 'checked'
            : 'warning'
        : 'unchecked';

    return (
        <div className={styles.pwdRiskRoot}>
            <div className={classlist(styles.item, styleMap[lengthStyle].className)}>
                <img src={styleMap[lengthStyle].icon} alt="length" />
                {__('The password must be 8-24 characters long.')}
            </div>
            <div className={classlist(styles.item, styleMap[typeStyle].className)}>
                <img src={styleMap[typeStyle].icon} alt="type" />
                {__(
                    'It must contain at least 3 of the following: letters, lowercase letters, numbers, or punctuation.'
                )}
            </div>
            <div className={classlist(styles.item, styleMap[confirmPasswordStyle].className)}>
                <img src={styleMap[confirmPasswordStyle].icon} alt="confirmPassword" />
                {__('The password must be the same as the confirm password.')}
            </div>
        </div>
    );
};

export default PwdRisk;
